import { Subject } from 'rxjs';
// Note: replaced $cacheFactory('subjectCache') by an object key-value
/**
 * @ngdoc service
 * @name proximus.core.entity:EntitySubjectPool
 * @description
 * # EntitySubjectPool
 *  Manages entity subject cache.
 */
export default class EntitySubjectPool {
    constructor() {
        this.pxEntityManagerSubjectCache = window.pxEntityManagerSubjectCache;
        if (this.pxEntityManagerSubjectCache === undefined) {
            window.pxEntityManagerSubjectCache = {};
            this.pxEntityManagerSubjectCache = window.pxEntityManagerSubjectCache;
        }
    }
    getEntitySubject(uniqueKey) {
        return this.pxEntityManagerSubjectCache[uniqueKey];
    }
    createEntitySubject(uniqueKey) {
        const subject = new Subject();
        if (uniqueKey) {
            this.pxEntityManagerSubjectCache[uniqueKey] = subject;
            subject.subscribe(
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => { }, () => {
                this.removeSubjectFromCache(uniqueKey);
            }, () => {
                this.removeSubjectFromCache(uniqueKey);
            });
        }
        return subject;
    }
    removeSubjectFromCache(uniqueKey) {
        delete this.pxEntityManagerSubjectCache[uniqueKey];
    }
}
